import { render } from "./Homevideo.vue?vue&type=template&id=c9a8d78a"
import script from "./Homevideo.vue?vue&type=script&lang=js"
export * from "./Homevideo.vue?vue&type=script&lang=js"

import "./Homevideo.vue?vue&type=style&index=0&id=c9a8d78a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__